import { render, staticRenderFns } from "./BetResultBlock.vue?vue&type=template&id=57119880&scoped=true"
import script from "./BetResultBlock.vue?vue&type=script&lang=js"
export * from "./BetResultBlock.vue?vue&type=script&lang=js"
import style0 from "./BetResultBlock.vue?vue&type=style&index=0&id=57119880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57119880",
  null
  
)

export default component.exports